<template>
	<div class="login">
		<div class="logo">
			<img src="../../assets/images/User/logo.png" alt="">
		</div>
		<div class="loginForm">
			<van-cell-group>
			  <img src="../../assets/images/User/User_userName.png" alt="">
			  <van-field v-model="formData.mobile" placeholder="请输入手机号" clearable />
			</van-cell-group>
			<van-cell-group>
			  <img src="../../assets/images/User/User_pass.png" alt="">
			  <van-field v-model="formData.password" placeholder="请输入密码" type="password" clearable/>
			</van-cell-group>
			<button class="wxLogin" @click="wxLogin">微信登录</button>
			<button @click="Login">登录</button>
		</div>
		<div class="operation">
			<router-link to="/user/register">快速注册</router-link>
			<span></span>
			<router-link to="/user/forget">忘记密码</router-link>
		</div>
		<div class="tip" ref="tip">专注血管外科领域宣传与继续教育新媒体</div>
	</div>
</template>
<script>
	import {Wechatauth,Login,GetUserInfo} from '../../config/interface.js'
	export default{
		data(){
			return{
				value:'',
				formData:{
					userName:'',
					password:''
				}
			}
		},
		mounted(){
			let screenHeight = document.documentElement.clientHeight;
			window.onresize=()=>{
				if(screenHeight>document.documentElement.clientHeight){
					this.$refs.tip.style.position='static';
				}else{
					this.$refs.tip.style.position='absolute';
				}
			}
		},
		methods:{
			//登录
			Login(){
				if(this.formData.mobile==''){
					common.toast('请输入手机号',1000)		
				}else if(this.formData.password==''){
					common.toast('请输入密码',1000)						
				}else{
					const url=Login;
					const method="POST"
					let params={
						mobile:this.formData.mobile,
						password:this.formData.password
					}
					fetch(url,params,method)
					.then((res)=>{
						if(res.code==0){
							this.getUserInfo();
						}
					})

				}
			},
			//获取用户信息
			getUserInfo(){
				const url=GetUserInfo;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						 localStorage.setItem('userInfo',JSON.stringify(data));
           				 this.$store.dispatch('storageUserInfo',data);
           				 let url=this.$route.query.url?this.$route.query.url:null;
           				 common.toast('登录成功',1000,'success',()=>{
	           				 if(url){
	           				 	window.location.href=url
	           				 }else{
	           				 	this.$router.push({
	           				 		path:'/'
	           				 	})
	           				 }
           				 })
					}
				})
			}
		}
	}
</script>
<style lang="scss">
	.login{
		position:relative;
		width:100%;
		height:100%;
		.logo{
			padding:55px 0;
			padding-bottom:65px;
			text-align:center;
			img{
				width:80%;
			}
		}
		.loginForm{
			.van-cell-group{
				width:295px;
				height:44px;
				box-sizing:border-box;
				margin:0 auto;
				margin-bottom:20px;
				@include flex(row);
				align-items:center;
				border: 1px solid #D3D3D3;
				border-radius: 23px;
				padding-left:15px;
				padding-right:5px;
				.van-cell{
					padding:0px 10px;
					background:transparent;
					input{
						height:44px;
					}
					input::-webkit-input-placeholder{
						color:#ababab;
						font-size:14px;
					}
				}
				img{
					height:25px;
				}
			}
			.wxLogin{
				margin-bottom:15px;
				background:#07c160;
			}
			button{
				display:block;
				margin:0 auto;
				width:295px;
				height:44px;
				background: #901d22;
				font-size:17px;
				color:#fff;
				border:0px;
				border-radius:23px;
			}
		}
		.operation{
			width:180px;
			margin:20px auto;
			@include flex(row);
			justify-content: space-around;
			align-items:center;
			a{
				color:#666;
				font-size:14px
			}
			span{
				border-left:1px solid #666;
				height:15px;
			}
		}
		.tip{
			position:absolute;
			bottom:20px;
			width:100%;
			text-align:center;
			font-size:13px;
			color:$color-main;
			letter-spacing:.5px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/User/login.vue